/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.lti").
controller("AssignmentRouteController", function AssignmentRouteController(
	$location,
	$routeParams,
	$http,
	$interval,
	$filter,
	$window,

	dxSession,
	dxExam,
	examState,
	examStatus,
	student,
	RoleTypeEnum,
	DX_URLS,
	dxTime,

	dxDialog,
	dxLocalize
) {
	"use strict";

	var self = this;

	// Get the query string params from LTI launch redirect.
	var params = $location.search();
	var organizationId = params.nodeId;
	var contextId = params.context_id;
	var sourcedId = params.lis_result_sourcedid;
	var qh = params.qh;

	this.examState = examState;
	this.examStatus = examStatus;
	this.examId = $routeParams.examId ? parseInt($routeParams.examId, 10) : 0;
	this.publicInfo = {};
	this.examOwner = false;
	this.student = null;
	this.settings = null;
	this.user = dxSession.getUser();
	var roleType = dxSession.getRole().roleType;
	this.showTeacherView = roleType === RoleTypeEnum.TEACHER || roleType === RoleTypeEnum.ADMIN;
	this.elapsedTime = null;
	this.hasLastSync = false; // eslint-disable-line no-sync
	this.examEndedNotPublished = false;
	this.examSelectedOrActive = false;
	this.register = register;
	this.loading = false;

	// Setup language-specific support articles.
	if (dxLocalize.getLanguage() === "sv") {
		this.supportLinks = {
			takingAnExam: "https://digiexam.zendesk.com/hc/sv/sections/201323771-Skriva-prov-tenta-med-DigiExam",
		};
	} else {
		this.supportLinks = {
			takingAnExam: "https://digiexam.zendesk.com/hc/en-us/sections/201323771-Write-an-exam-with-DigiExam",
		};
	}

	if (this.examId === 0) {
		this.publicInfo.status = examStatus.NOT_SELECTED;
		return;
	}

	this.locateToLiveView = function locateToLiveView() {
		dxExam.getPublicInfo(self.examId).then(function onSuccess(responseData) {
			if (responseData.status <= examStatus.ACTIVE) {
				$window.open("#" + DX_URLS.get("examView", {id: self.examId}), "_blank");
			} else {
				$window.open("#" + DX_URLS.get("examGrades", {id: self.examId}), "_blank");
			}
		});
	};

	// Get the exam data.
	dxExam.getPublicInfo(self.examId).then(function onSuccess(responseData) {
		self.publicInfo = responseData;
		self.examOwner = self.publicInfo.userId === dxSession.getUser().id;

		// If the LTI course ID does not match the provided context ID the exam was copied.
		// Set status -1 to denote that no exam has been selected.
		if (self.publicInfo.ltiCourseId !== contextId) {
			self.publicInfo.status = examStatus.NOT_SELECTED;
		}

		// If the exam has already started, and the user is a teacher,
		// we start the elapsed time function with a 1 s interval.
		if (self.publicInfo.status === examStatus.ACTIVE && self.showTeacherView) {
			$interval(updatedElapsedTime, 1000);
		}

		// Shorthand expression for when an exam is either selected or active.
		if (self.publicInfo.status === examStatus.NOT_STARTED || self.publicInfo.status === examStatus.ACTIVE) {
			self.examSelectedOrActive = true;
		}

		// Shorthand expression for when an exam is either ended or graded.
		if (self.publicInfo.status === examStatus.NOT_GRADED || self.publicInfo.status === examStatus.GRADED) {
			self.examEndedNotPublished = true;
			self.stopMonth = $filter("date")(self.publicInfo.stop, "M");
		}

		if (self.publicInfo.status === examStatus.PUBLISHED) {
			self.syncMonth = $filter("date")(self.publicInfo.ltiLastGradeSync, "M"); // eslint-disable-line no-sync
			self.hasLastSync = new Date(self.publicInfo.ltiLastGradeSync).getYear() > 1; // eslint-disable-line no-sync
			self.publicInfo.ltiCourseTitle = self.publicInfo.ltiCourseTitle.charAt(0).toUpperCase() + self.publicInfo.ltiCourseTitle.slice(1);
		}

		// If the user is a student we get the student (and settings)
		// data as well.
		if (!self.showTeacherView) {
			getStudent();
		}
	});

	function getStudent() {
		student.getByUserAndOrganization(self.user.id, organizationId).then(function onSuccess(responseData) {
			for (var i = 0; i < responseData.data.length; i++) {
				// Find out if a student is already registered for this exam.
				// If so, get the student settings.
				if (responseData.data[i].examIds.indexOf(self.examId) > -1) {
					self.student = responseData.data[i];
					dxExam.getSettings(self.examId, self.student.id).then(onGetSettingsSuccess);
					break;
				}
			}
		});
	}

	function onGetSettingsSuccess(responseData) {
		self.settings = responseData;
	}

	function updatedElapsedTime() {
		self.elapsedTime = dxTime.elapsed(self.publicInfo.start);
	}

	function register() {
		self.loading = true;
		var data = {
			examId: self.examId,
			contextId: contextId,
			lisResultSourcedid: sourcedId,
			organizationId: parseInt(organizationId, 10),
			qh: qh,
		};

		$http.post("/lti/register", data).then(onPostSuccess, onPostError);

		function onPostSuccess(response) {
			self.student = response.data.student;
			self.settings = response.data.settings;
		}

		function onPostError() {
			self.loading = false;
			dxDialog.alert({
				title: dxLocalize.get("UnableToRegister"),
				body: dxLocalize.get("UnableToRegister.Info"),
				acceptText: dxLocalize.get("Close"),
			});
		}
	}
});
